import {DomainStore} from 'shared/store';
import { makeAutoObservable } from 'mobx';
import {configureHighcharts} from 'shared/tools';
import HighchartsReact from 'highcharts-react-official';
import {endpoints, types} from 'main/tools';
import {SurveyQuestion, SurveyResult} from 'main/stores/surveys';
import _ from 'lodash';
import SentimentViewModel from './SentimentViewModel';
import TextAreaViewModel from './TextAreaViewModel';
import MultipleChoiceViewModel from './MultipleChoiceViewModel';
import MultiSelectViewModel from './MultiSelectViewModel';

class SummaryContainerState {
  store = new DomainStore();
  match;
  history;
  scope;
  Highcharts;
  HighchartsReact;

  survey;
  results;
  questionSummaries;

  questionId;
  contentFilter;
  reviewersModalOpen = false;

  constructor() {
    makeAutoObservable(this, {
      store: false,
      history: false
    });
  }

  receiveProps({match, history, scope, survey}) {
    this.match = match;
    this.history = history;
    this.scope = scope;
    this.survey = survey;
  }

  async load() {
    const [highcharts] = await Promise.all([
      import('highcharts/esm/highcharts'),
      this.store._compose([
        endpoints.SURVEYS.RESULTS.with(this.match.params.id)
      ])
    ]);

    this.Highcharts = configureHighcharts(highcharts.default);
    this.HighchartsReact = HighchartsReact;

    this.questions = this.store._getAll(
      types.SURVEYS.QUESTION, SurveyQuestion
    );

    this.results = new SurveyResult(this.store._getSingle(types.SURVEYS.RESULT));

    this.questionSummaries = _.map(this.sortedQuestions,
      question => {
        const inputs = {
          question: question,
          trend: this.results.trend,
          uiState: this,
          periodDate: this.results.currentPeriodDate
        };
        switch (question.questionType) {
          case 'multiple_choice':
            return new MultipleChoiceViewModel(inputs);
          case 'multi_select':
            return new MultiSelectViewModel(inputs);
          case 'sentiment':
            return new SentimentViewModel(inputs);
          case 'text_area':
            return new TextAreaViewModel(inputs);
          default:
            throw new Error(`Question type ${question.questionType} not supported.`);
        }
      }
    );
  }

  openReviewersModal(questionId, content, periodDateFilter) {
    if (this.survey.anonymous) return null;

    this.periodDateFilter = periodDateFilter;
    this.contentFilter = content;
    this.questionId = questionId;
    this.reviewersModalOpen = true;
  }

  onPointClicked(highchartsEvent, questionId) {
    this.openReviewersModal(
      questionId,
      highchartsEvent.point.series.name,
      highchartsEvent.point.custom.periodDate
    );
  }

  closeReviewersModal() {
    this.reviewersModalOpen = false;
  }

  get sortedQuestions() {
    return _.sortBy(this.questions, 'order');
  }

  get hasTrends() {
    return !_.isEmpty(this.results.trend);
  }
}

export default SummaryContainerState;
